"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var ExportedEntity_1 = require("../../export/model/ExportedEntity");

var ExportedEntityState_1 = require("../../export/model/ExportedEntityState");

var UserInfo_1 = require("../../user/model/UserInfo");
/**
 * Representation of the promotion in export queue.
 *
 * @author VRu
 */


var ExportedPromotion =
/*#__PURE__*/
function (_ExportedEntity_1$Exp) {
  _inherits(ExportedPromotion, _ExportedEntity_1$Exp);

  /**
   * Creates new exported promotion.
   * @param id identifier of record in the queue
   * @param entityIds ids of promotions
   * @param state state of export
   * @param created time of creation of record
   * @param createdBy user who created this record
   * @param lastModified time of last modification of this record
   * @param nextAttempt time of next planned export attempt
   * @param attemptCount count of attempts, starts with 0; 1 after first successful of failed attempt
   * @param requestId request id returned from IDB
   * @param error description of last error if this record is in failed state
   * @param processId ID of application instance that is responsible for export
   */
  function ExportedPromotion(id, entityIds, state, created, createdBy, lastModified, nextAttempt, attemptCount, requestId, error, processId) {
    var _this;

    _classCallCheck(this, ExportedPromotion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedPromotion).call(this, id, state, created, createdBy, lastModified, nextAttempt, attemptCount, requestId, error, processId));
    _this.id = id;
    _this.entityIds = entityIds;
    _this.state = state;
    _this.created = created;
    _this.createdBy = createdBy;
    _this.lastModified = lastModified;
    _this.nextAttempt = nextAttempt;
    _this.attemptCount = attemptCount;
    _this.requestId = requestId;
    _this.error = error;
    _this.processId = processId;
    return _this;
  }

  return ExportedPromotion;
}(ExportedEntity_1.ExportedEntity);

exports.ExportedPromotion = ExportedPromotion;

ExportedPromotion.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ExportedPromotion.name);
  return {
    id: builder.id('id'),
    entityIds: builder.listOf(builder.str('entityIds')),
    state: builder.senum('state', ExportedEntityState_1.ExportedEntityState, 'seq'),
    created: builder.date('created', DateParser_1.DateParser.ISO_PATTERN),
    createdBy: builder.obj('createdBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    lastModified: builder.date('lastModified', DateParser_1.DateParser.ISO_PATTERN),
    nextAttempt: builder.date('nextAttempt', DateParser_1.DateParser.ISO_PATTERN),
    attemptCount: builder.num('attemptCount'),
    requestId: builder.opt(builder.num('requestId')),
    error: builder.opt(builder.str('error').withDescription({
      multiline: true
    })),
    processId: builder.opt(builder.str('processId'))
  };
}();